const PREFIX = '[LOGIN MENU]';

export const SET_MENU_STATE = `${PREFIX} SET_MENU_STATE`;

export const setMenuState = isMenuOpen => ({
  type: SET_MENU_STATE,
  isMenuOpen,
});

export const toggleMenu = state => (dispatch) => {
  dispatch(setMenuState(!state));
};

export const closeMenu = ({ target: { parentElement = {} } = {} }) => (dispatch) => {
  if (parentElement && parentElement.getAttribute('data-trigger')) return;

  dispatch(setMenuState(false));
};



// WEBPACK FOOTER //
// ./src/store/actions/loginMenu.js